import React, { Component } from "react";
import { Icon } from "antd";

class Error extends Component {
  render() {
    return (
      <div className="error-boundary-container">
        <div>
          <span>
            <h1>
              <Icon type="message" className="error-boundary-icon" />
              S'ha produït un error
            </h1>
            <p>
              En aquests moments no es pot mostrar el contingut de la pàgina.
            </p>
            <p>
              Si l'error persisteix, contacta amb{" "}
              <a href="mailto:fenocat.meteocat@gencat.cat">
                fenocat.meteocat@gencat.cat
              </a>
            </p>
          </span>
        </div>
      </div>
    );
  }
}

export default Error;
